import { Card, CardBody, CardFooter, Heading, HStack, IconButton, Image, Stack, Tag, Text } from '@chakra-ui/react';

// icons
import { FaAndroid, FaAppStoreIos, FaGithub, FaGlobe } from 'react-icons/fa';
import { PROJECT, PROJECT_TYPE } from '../../data/projects';

interface ProjectCardProps {
  project: PROJECT;
}
export const ProjectCard = ({ project }: ProjectCardProps) => {
  return (
    <Card bg={'#f9f9f9'} mt={10}>
      <CardBody width={'100%'} height={'100%'}>
        <Image width={'100%'} src={project.image} alt="Green double couch with wooden legs" borderRadius="lg" />
        <Stack mt="6" spacing="3">
          <HStack justifyContent="space-between">
            <Heading size="md">{project.title}</Heading>
            <HStack spacing="1">
              {project.types.map(type => (
                <Tag key={type} colorScheme="green" variant="subtle">
                  {type}
                </Tag>
              ))}
            </HStack>
          </HStack>
          <Text>{project.description}</Text>
          <HStack spacing="2" mt={2} flexWrap="wrap">
            {project.techStacks.map(tech => (
              <Tag key={tech} colorScheme="blue" variant="subtle">
                {tech}
              </Tag>
            ))}
          </HStack>
        </Stack>
      </CardBody>
      <CardFooter>
        <HStack spacing="2" width={'100%'} justifyContent="space-between">
          {/* <Button variant="solid" colorScheme="blue">
            View Details
          </Button> */}
          <HStack spacing="2">
            <IconButton
              isRound={true}
              variant="outline"
              colorScheme="gray"
              aria-label="github icon"
              fontSize="20px"
              icon={<FaGithub />}
              onClick={() => window.open(project.githubUrl, '_blank')}
            />
            {project.types.includes(PROJECT_TYPE.WEB) && (
              <IconButton
                isRound={true}
                variant="outline"
                colorScheme="gray"
                aria-label="website icon"
                fontSize="20px"
                icon={<FaGlobe />}
                onClick={() => window.open(project.websiteUrl, '_blank')}
              />
            )}
            {project.types.includes(PROJECT_TYPE.IOS) && (
              <IconButton
                isRound={true}
                variant="outline"
                colorScheme="gray"
                aria-label="website icon"
                fontSize="20px"
                icon={<FaAppStoreIos />}
                onClick={() => window.open(project.appStoreUrl, '_blank')}
              />
            )}
            {project.types.includes(PROJECT_TYPE.ANDROID) && (
              <IconButton
                isRound={true}
                variant="outline"
                colorScheme="gray"
                aria-label="website icon"
                fontSize="20px"
                icon={<FaAndroid />}
                onClick={() => window.open(project.appStoreUrl, '_blank')}
              />
            )}
          </HStack>
        </HStack>
      </CardFooter>
    </Card>
  );
};
